import React from 'react';
import { useIntl } from 'react-intl';

import TabsHeader from 'components/tabs-header';
import { Settings as SettingsIcon } from 'lucide-react';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const SettingsTabHeader: React.FC<Props> = ({ intro, actions, utils }) => {
  const intl = useIntl();

  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: true,
          label: intl.formatMessage({ id: 'sidebar.settings' }),
          to: '/settings',
        },
      ]}
      intro={intro}
      actions={actions}
      utils={utils}
      icon={<SettingsIcon size={25} color={'white'} />}
    />
  );
};

export default React.memo(SettingsTabHeader);
